import { render, staticRenderFns } from "./CampaignObjective.vue?vue&type=template&id=7995012e&"
import script from "./CampaignObjective.vue?vue&type=script&lang=js&"
export * from "./CampaignObjective.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports